<template>
	<AppPage>
		<AppPageTitle full-width class="pb-0">
			<div>
				<h2>Advies</h2>
			</div>
			<template #actions>
				<AppTabBar :tabs="tabs" />
			</template>
		</AppPageTitle>
		<RouterView v-slot="{ Component }">
			<KeepAlive>
				<component :is="Component" />
			</KeepAlive>
		</RouterView>
	</AppPage>
</template>

<script setup lang="ts">
const tabs = [{ name: "Pensioenadvies", label: "Pensioen", id: 0 }];
</script>
